/** Survives checkout ↔ reservar navigation within the same browser tab. */
export const PENDING_BOOKING_SELECTION_KEY = 'tfr_pending_booking_selection';

export interface PendingBookingSelection {
  spaceId: string;
  date: string;
  startTime: string;
  endTime: string;
  hasCleaning: boolean;
}

function canUseSessionStorage(): boolean {
  return typeof sessionStorage !== 'undefined';
}

export function savePendingBookingSelection(data: PendingBookingSelection): void {
  if (!canUseSessionStorage()) return;
  try {
    sessionStorage.setItem(PENDING_BOOKING_SELECTION_KEY, JSON.stringify(data));
  } catch {
    /* quota / private mode */
  }
}

export function peekPendingBookingSelection(spaceId: string): PendingBookingSelection | null {
  if (!canUseSessionStorage()) return null;
  const id = spaceId.trim();
  if (!id) return null;
  try {
    const raw = sessionStorage.getItem(PENDING_BOOKING_SELECTION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PendingBookingSelection;
    if (parsed.spaceId !== id) return null;
    if (!parsed.date?.trim() || !parsed.startTime?.trim() || !parsed.endTime?.trim()) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearPendingBookingSelection(): void {
  if (!canUseSessionStorage()) return;
  sessionStorage.removeItem(PENDING_BOOKING_SELECTION_KEY);
}
